import { atom } from 'recoil';

export const localeLoaderAtom = atom({
  key: 'localeLoader',
  default: false,
});
